var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConversions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11.25,
    viewBox: "0 0 15 11.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M4.922-2.812a.207.207,0,0,1-.234-.234v-7.031a.207.207,0,0,1,.234-.234h.469a.207.207,0,0,1,.234.234v7.031a.207.207,0,0,1-.234.234Zm-2.812,0a.207.207,0,0,1-.234-.234V-7.266A.207.207,0,0,1,2.109-7.5h.469a.207.207,0,0,1,.234.234v4.219a.207.207,0,0,1-.234.234Zm-5.625,0a.207.207,0,0,1-.234-.234V-5.391a.207.207,0,0,1,.234-.234h.469a.207.207,0,0,1,.234.234v2.344a.207.207,0,0,1-.234.234Zm2.813,0a.207.207,0,0,1-.234-.234V-9.141A.207.207,0,0,1-.7-9.375h.469A.207.207,0,0,1,0-9.141v6.094a.207.207,0,0,1-.234.234ZM7.266-.937A.207.207,0,0,1,7.5-.7v.469A.207.207,0,0,1,7.266,0h-14.3a.456.456,0,0,1-.337-.132A.456.456,0,0,1-7.5-.469V-11.016a.207.207,0,0,1,.234-.234H-6.8a.207.207,0,0,1,.234.234V-.937Z",
    transform: "translate(7.5 11.25)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversions);
export default __webpack_public_path__ + "static/media/conversions.a9130638839c558832a149fe4e1e73fa.svg";
export { ForwardRef as ReactComponent };